import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const InfoIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 18 18", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round", fill: "none" },
            React.createElement("circle", { cx: "9", cy: "9", r: "8" }),
            React.createElement("path", { d: "M9.00053 11.0351V5.00903" }),
            React.createElement("path", { d: "M9.00053 13.7741V13.5002" }))));
};
export default InfoIcon;
//# sourceMappingURL=index.js.map